import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(relativeTime);
dayjs.extend(utc);
dayjs.extend(timezone);

export const shortenWord = (word, maxLength) => {
  if (word.length > maxLength) {
    return word.slice(0, maxLength) + '...';
  }
  return word;
};
export const getInitials = name => {
  const parts = name.trim().split(/\s+/);

  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase();
  }

  const first = parts[0][0];
  const last = parts[parts.length - 1][0];

  return (first + last).toUpperCase();
};
// FileExchange rows store `fileSize` in gigabytes as a fraction (see
// fileExchangeController.createFile: `file.size / (1024**3)`). Rendering
// the raw value produced strings like "0.000186" next to a filename.
// This normaliser accepts either the GB-fraction storage OR raw bytes
// (some older rows) and picks the tightest human-readable unit.
export function formatFileSize(v) {
  if (v == null || v === '' || Number.isNaN(Number(v))) return '';
  const n = Number(v);
  // Values under 1 are almost certainly the GB-fraction storage;
  // convert to bytes. Values >= 1 are raw bytes.
  const bytes = n < 1 ? n * 1024 * 1024 * 1024 : n;
  if (bytes < 1024)                return `${Math.round(bytes)} B`;
  if (bytes < 1024 * 1024)         return `${(bytes / 1024).toFixed(1)} KB`;
  if (bytes < 1024 * 1024 * 1024)  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} GB`;
}

export function formatHumanDate(date, showOnlyDate=false, tz=null) {
  // Always resolve to a stable, explicit timezone. When the caller passes
  // one (typically tenantConfig.locale.timezone), use it; otherwise fall
  // back to UTC — NOT browser-local. Falling to browser-local made the
  // same audit row show different times per reload depending on when
  // tenantConfig had hydrated in Redux, and also produced ~5h drift
  // between UTC-stored timestamps and CT/PT users. UTC as the fallback
  // means the value is stable and interpretable across reloads.
  const zone = tz || 'UTC';
  const base = dayjs(date).tz(zone);
  const daysDiff = dayjs().diff(base, 'day');

  if (daysDiff < 7 && !showOnlyDate) {
    return base.fromNow();
  }

  const suffix = zone === 'UTC' ? ' UTC' : '';
  return base.format('DD MMM YYYY hh:mm A') + suffix;
}
